<template>
  <div data-vv-value-path="model" :data-vv-as="label">
    <label v-if="label" class="wysiwyg-label">{{ label }}</label>

    <editor
      v-model="model"
      v-if="basic"
      :init="{
        menubar: false,
        relative_urls : false,
        remove_script_host: false,
        force_br_newlines: true,
        force_p_newlines: false,
        forced_root_block: '',
        plugins: 'autoresize spellchecker paste',
        autoresize_min_height: 300,
        autoresize_max_height: 580,
        toolbar: 'undo redo | bold italic underline strikethrough ' +
          '| alignleft aligncenter alignright alignjustify | outdent indent | spellchecker',
        skin: false,
        spellchecker_callback: spellcheck,
        spellchecker_wordchar_pattern: /\b[^\d\W]+\b/gi,
        spellchecker_languages: '',
        setup: function(editor) {
          editor.on('blur', function() {
            var newContent = editor.getContent();
            // Fire an event to let its parent know
            $emit('change', newContent);
          });
        },
        content_style: css,
        content_css: racDocumentMode ? contentCssUrl : null,
        body_class: racDocumentMode ? 'rac-document' : undefined,
      }"
    />
    <editor
      v-model="model"
      v-else
      :init="{
      relative_urls : false,
      remove_script_host: false,
      height: editorHeight,
      force_br_newlines: true,
      force_p_newlines: false,
      forced_root_block: '',
      images_upload_url: '/api/upload-wysiwyg-image',
      images_upload_base_path: '/storage/wysiwyg',
      plugins: 'code textcolor colorpicker lists image link media hr table spellchecker directionality wordcount paste',
      toolbar: 'code | insertfile undo redo | styleselect | bold italic underline strikethrough forecolor backcolor ' +
        '| alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image media | hr table ' +
        '| spellchecker',
      skin: false,
      spellchecker_callback: spellcheck,
      spellchecker_wordchar_pattern: /\b[^\d\W]+\b/gi,
      spellchecker_languages: '',
      setup: function(editor) {
        editor.on('blur', function() {
          var newContent = editor.getContent();
          // Fire an event to let its parent know
          $emit('change', newContent);
        });
      },
      content_style: css,
      content_css: racDocumentMode ? contentCssUrl : null,
      body_class: racDocumentMode ? 'rac-document' : undefined,
    }"
    />

    <input type="hidden" :name="name" :id="id" v-model="model">
  </div>
</template>

<script>
import MobileDetect from "mobile-detect/mobile-detect";
import Editor from "@tinymce/tinymce-vue";
import tinymce from "tinymce";
import "tinymce/themes/modern";
import "tinymce/plugins/code/plugin";
import "tinymce/plugins/textcolor/plugin";
import "tinymce/plugins/colorpicker/plugin";
import "tinymce/plugins/lists/plugin";
import "tinymce/plugins/image/plugin";
import "tinymce/plugins/link/plugin";
import "tinymce/plugins/media/plugin";
import "tinymce/plugins/hr/plugin";
import "tinymce/plugins/table/plugin";
import "tinymce/plugins/spellchecker/plugin";
import "tinymce/plugins/directionality/plugin";
import "tinymce/plugins/wordcount/plugin";
import "tinymce/plugins/autoresize/plugin";
import "tinymce/plugins/paste/plugin";
import field from "../mixins/field";

window.MobileDetect = MobileDetect;

export default {
  methods: {
    spellcheck(method, text, successFunction, failureFunction) {
      tinymce.util.JSONRequest.sendRPC({
        url: "/spellcheck",
        method: "spellcheck",
        params: {
          lang: "en",
          words: text
        },
        success(response) {
          successFunction(response);
        },
        error(error, xhr) {
          failureFunction("Spellcheck error:" + xhr.status);
        }
      });
    },
    getDpi() {
      return document.getElementById("dpi-test").offsetHeight;
    }
  },
  computed: {
    css() {
      let css = "";
      var md = new MobileDetect(window.navigator.userAgent);
      css =
        "html { width: " +
        195 / 25.4 * this.getDpi() +
        "px;}" +
        "body { font-family:Arial;background-color:#ffffff;margin-left:0px;margin-top:5px;margin-right:" +
        22.45 / 25.4 * this.getDpi() +
        "px;margin-bottom:5px; }" +
        "body, table { font-family:Arial;font-size:12px; }" +
        "a:link,a:hover,a:active,a:visited { color:#000000; }" +
        "table { border-collapse: collapse; }" +
        "thead { vertical-align: bottom; text-align: center; font-weight: bold; }" +
        "tfoot { text-align: center; font-weight: bold; }" +
        "th { text-align: left; padding-left: 0.35em; padding-right: 0.35em; padding-top: 0.35em; padding-bottom: 0.35em; vertical-align: top; }" +
        "td { padding-left: 0.35em; padding-right: 0.35em; padding-top: 0.35em; padding-bottom: 0.35em; vertical-align: top; }" +
        "img { margin: 0.2em; vertical-align: middle; }" +
        ".mce-spellchecker-word {text-decoration: underline wavy red; color:red; font-style: italic;}";
      if (
        (md.mobile() !== "" && md.mobile() !== null) ||
        (md.tablet() !== "" && md.tablet() !== null)
      ) {
        css =
          "body { font-family:Arial;background-color:#ffffff;}" +
          "body, table { font-family:Arial;font-size:12px; }" +
          "a:link,a:hover,a:active,a:visited { color:#000000; }" +
          "table { border-collapse: collapse; }" +
          "thead { vertical-align: bottom; text-align: center; font-weight: bold; }" +
          "tfoot { text-align: center; font-weight: bold; }" +
          "th { text-align: left; padding-left: 0.35em; padding-right: 0.35em; padding-top: 0.35em; padding-bottom: 0.35em; vertical-align: top; }" +
          "td { padding-left: 0.35em; padding-right: 0.35em; padding-top: 0.35em; padding-bottom: 0.35em; vertical-align: top; }" +
          "img { margin: 0.2em; vertical-align: middle; }" +
          ".mce-spellchecker-word {text-decoration: underline wavy red; color:red; font-style: italic;}";
      }

      // Slice X4 v9: landlord proposal markup styling. Selectors only match spans
      // produced by AccountController::proposeChanges() and persisted to documents.description
      // — no other column or producer in the codebase emits these classes, so editors
      // outside the RAC review surface load these rules but never paint anything.
      css +=
        ".landlord-edit{color:#dc2626 !important;background:#fef2f2 !important}" +
        ".landlord-edit *{color:#dc2626 !important}" +
        ".landlord-deleted{color:#dc2626 !important;background:#fef2f2 !important;text-decoration:line-through !important}" +
        ".landlord-deleted *{color:#dc2626 !important;text-decoration:line-through !important}" +
        ".landlord-deleted-line{display:block !important;text-align:center !important;font-size:11px !important;color:#dc2626 !important;border-top:1px dashed #dc2626 !important;border-bottom:1px dashed #dc2626 !important;padding:3px 0 !important;margin:6px 0 !important}";

      return css;
    }
  },
  mixins: [field],
  components: {
    Editor
  },
  props: {
    id: {
      type: String,
      default: null
    },
    basic: {
      type: Boolean,
      default: false
    },
    value: {
      default() {
        return this.model;
      },
      type: [Number, String, Array, Object]
    },
    editorHeight: {
      default: 300,
      type: Number
    },
    // Opt-in: load the shared RAC document stylesheet into the TinyMCE iframe
    // (content_css) and tag its <body> with body_class:'rac-document', so
    // ordinary contract text renders Arial 12px with the same paragraph/list/
    // heading spacing as the public RAC preview and the PDF. VWysiwyg is shared
    // by many unrelated editors (mail bodies, CMS pages, ...), so this defaults
    // to false and must never apply automatically — only the admin RAC
    // description/description_2 fields opt in explicitly.
    racDocumentMode: {
      default: false,
      type: Boolean
    },
    // Versioned URL of the compiled RAC stylesheet (mix('css/rac-document.css')).
    // Only consulted when racDocumentMode is true.
    contentCssUrl: {
      default: null,
      type: String
    }
  }
};
</script>
